module.exports = __webpack_public_path__ + "img/Retail_Recall_3_Set.68166dbf.png";